import Vue from "vue";
import Vuex from "vuex";
import { IMenuState } from "./modules/menu";
import { ISigninState } from "./modules/signin";
import { IUserState } from "./modules/user";
Vue.use(Vuex);

export interface IRootState {
  signin: ISigninState;
  user: IUserState;
  menu: IMenuState;
}
export default new Vuex.Store<IRootState>({});
